import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MSAL_INSTANCE, MsalBroadcastService, MsalModule, MsalService } from '@azure/msal-angular';
import { BrowserCacheLocation, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { UiKitModule } from '@serviceplan/ui-kit';
import { CaptchaPopupComponent } from '@thehubz/client/captcha';
import { ClientEnvironment, ENVIRONMENT, MatComponentsModule } from '@thehubz/client/core';
import { ApiModule } from '@thehubz/client/data-access-api';
import { ConfirmEmailComponent } from './components/confirm-email/confirm-email.component';
import { ContentComponent } from './components/content/content.component';
import { LoginComponent } from './components/login/login.component';
import { ResetPasswordEmailComponent } from './components/reset-password-email/reset-password-email.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { LoginRoutingModule } from './login-routing.module';
import { SignUpSuccessComponent } from './sign-up-success/sign-up-success.component';
import { SignUpComponent } from './sign-up/sign-up.component';

// eslint-disable-next-line @typescript-eslint/no-empty-function
function loggerCallback(logLevel: LogLevel, message: string) {}

const MSALInstanceFactory = (injector: Injector): IPublicClientApplication => {
  const env: ClientEnvironment = injector.get(ENVIRONMENT);
  return new PublicClientApplication({
    auth: {
      clientId: env.azureAD?.clientId ?? '',
      authority: `https://login.microsoftonline.com/${env.azureAD?.tenantId}`,
      redirectUri: env.azureAD?.redirectUri,
      postLogoutRedirectUri: `${env.azureAD?.redirectUri}/login`,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: true,
      },
    },
  });
};

@NgModule({
  declarations: [
    LoginComponent,
    ResetPasswordComponent,
    ContentComponent,
    ResetPasswordEmailComponent,
    SignInComponent,
    SignUpComponent,
    SignUpSuccessComponent,
    ConfirmEmailComponent,
  ],
  imports: [CommonModule, LoginRoutingModule, MatComponentsModule, FormsModule, ReactiveFormsModule, ApiModule, MsalModule, UiKitModule, CaptchaPopupComponent],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
      deps: [Injector],
    },
    MsalService,
    MsalBroadcastService,
  ],
  exports: [ResetPasswordComponent, ResetPasswordEmailComponent, ConfirmEmailComponent],
})
export class ClientLoginModule {}
